<template>
  <block-title
    class="goodsStock overview"
    :show-line="false"
    title="货品库存分析"
  >
    <div class="goodsBox">
      <div class="top">
        <a-row :gutter="16">
          <a-col :span="2">
            <span>仓库</span>
          </a-col>
          <a-col :span="16">
            <cascaderSelect v-if="isEnterprise" style="width: 300px" @change="handleWarehoseChange"></cascaderSelect>
            <a-select v-else v-model="wearhouseCode" style="width: 300px" @change="onChange">
              <a-select-option v-for="item in ProjectList" :key="item.id" :value="item.value">
                {{item.label}}<span class="shipperName">({{item.shipperName}})</span>
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6">
            <span class="detailedText" @click="toGoods">查看库存明细</span>
          </a-col>
        </a-row>
      </div>
      <div class="bgTitle">
        <img class="bg" src="@/assets/img/icon/bg_green.png" alt="">
        <a-row>
          <a-col :span="12">
            <p class="number">{{goodStockNum}}</p>
            <p class="text">货品库存件数（整单位）</p>
          </a-col>
          <a-col :span="12">
            <p class="number">{{inStockSkuNum}}</p>
            <p class="text">在库货品SKU数量</p>
          </a-col>
        </a-row>
      </div>
      <div class="tableBox">
        <a-table
          :columns="columns"
          :data-source="goodsData"
          :pagination="false"
          size="middle"
          :locale="{emptyText: emptyImage}"
        >
          <div slot="ranking" slot-scope="text">
            <span :class="filterRank(text)">{{text}}</span>
            </div>
        </a-table>
      </div>
    </div>
  </block-title>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import cascaderSelect from '@/components/cascaderSelect/index.vue'
import { getWareHouse } from '../../../warehouseOrder/api'
import  { goodsStock } from '../api.js'
import Empty from './Empty.vue'

const columns = [
  {
    title: '排名',
    dataIndex: 'ranking',
    key: 'ranking',
    scopedSlots: { customRender: 'ranking' },
    width: 120,
  },
  {
    title: '货品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    ellipsis: true,
  },
  {
    title: '库存件数（整单位）',
    dataIndex: 'stockNum',
    key: 'stockNum',
    width: 180,
  },
];
export default {
  name: 'GoodsStock',
  components: {
    BlockTitle,
    cascaderSelect
  },
  data() {
    return {
      columns,
      goodsData: [],
      ProjectList: [],
      wearhouseCode: '',
      goodStockNum: '',
      inStockSkuNum: '',
      shipperId: '',
      isEnterprise:false
    }
  },
  computed: {
    emptyImage() {
      return <Empty />
    }
  },
  created(){
    const {creditCode}=this.$store.state.user
    this.isEnterprise=!!creditCode
    if(!creditCode){
      this.getWearhouse()
    }
  },
  methods: {
    handleWarehoseChange(value){
      this.shipperId = value.customerId
      this.wearhouseCode=value.value
      this.goodsData=[]
      if(!this.wearhouseCode){
        return
      }
      this.getData()
    },
    onChange(res){
      this.ProjectList.forEach((e) => {
        if(res === e.tenantId){
          this.shipperId = e.customerId
        }
      })
      this.getData()
    },
    toGoods() {
      this.$router.push('/data/inventory')
    },
    filterRank(rank){
      if(rank * 1 === 1){
        return "one all"
      }
      if(rank * 1 === 2){
        return "two all"
      }
      if(rank * 1 === 3){
        return "three all"
      }
      return "all"
    },
    getData(){
      goodsStock({
        warehouseCode: this.wearhouseCode,
        shipperId: this.shipperId
      }).then((res) => {
        this.inStockSkuNum = res.wmsGoodsStockNum.inStockSkuNum
        this.goodStockNum = res.wmsGoodsStockNum.goodStockNum
        this.goodsData = res.wmsGoodsSkuNumRank.map((e, i) => {
          return {
            ...e,
            ranking: i +1
          }
        })
      })
    },
    getWearhouse(){
      getWareHouse({
        customerCodes: [this.$store.state.user.customerCode],
        needExcludeDefaultTenant: true,
        isReadConfig:false
      },{size:500}).then((res) => {
        if(res.records.length <= 0){
          this.ProjectList = []
          return
        }
        const arr = res.records.map((e) => {
          return {
            ...e,
            label: e.tenantName,
            value: e.tenantId
          }
        })
        this.ProjectList = arr
        if(arr.length > 0){
          this.wearhouseCode = arr[0].value
          this.shipperId = arr[0].customerId
        }
        this.getData()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.goodsStock{
  .goodsBox{
    padding: 8px 32px 12px 32px;
  }
  .top{
    line-height: 32px;
    font-size: 14px;
    color: #171717;
    .detailedText{
      display: block;
      text-align: right;
      color: #06B880;
      &:hover{
        cursor: pointer;
      }
    }
  }
  .bgTitle{
    margin-top: 24px;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 24px 0;
    position: relative;
    .bg{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
    }
    .number{
      font-size: 36px;
      font-weight: bold;
    }
    .text{
      font-size: 18px;
    }
  }
  .tableBox{
    margin-top: 24px;
  }
}
/deep/.ant-cascader-picker{
  width: 100%;
  }
.shipperName {
  color: #ccc;
  margin-left: 10px;
}
.shipperName {
  color: #ccc;
  margin-left: 10px;
}
</style>